module.exports = __webpack_public_path__ + "img/certificacion.c535c80d.png";